import { red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 16,
    textTransform: 'uppercase',
  },
  general: {
    backgroundColor: '#eceff1',
    color: '#869ca6',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  title: {
    color: '#78909c',
    fontWeight: 500,
    fontSize: 16,
  },
  description: {
    fontSize: 14,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  buttonReprove: {
    background: red[700],
    color: '#ffffff',
    '&:hover': {
      backgroundColor: red[900],
    },
  },
  linkTooltip: {
    cursor: 'pointer',
  },
  tooltip: {
    backgroundColor: '#f3f3f3',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(14),
    border: '1px solid #dadde9',
  },
  tooltipTxt: {
    background: '#ffffff',
    padding: 6,
    marginTop: 4,
  },
  list: {
    width: '100%',
    position: 'relative',
    overflow: 'auto',
  },
  zone: {
    width: '100%',
    borderStyle: 'dashed',
    padding: 16,
    textAlign: 'center',
    cursor: 'pointer',
    color: '#5f6671',
    marginBottom: 16,
  },
  file: {
    background: '#f3f3f3',
    border: '1px solid #d8cccc',
    marginBottom: 4,
  },
  alert: {
    marginBottom: 16,
  },
}));

export default useStyle;
